import { render } from "./HorizontalImg.vue?vue&type=template&id=48d0723c&scoped=true"
import script from "./HorizontalImg.vue?vue&type=script&lang=js"
export * from "./HorizontalImg.vue?vue&type=script&lang=js"

import "./HorizontalImg.vue?vue&type=style&index=0&id=48d0723c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48d0723c"

export default script